<svelte:options tag={null} />

<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  import type { RadioGroupOption } from './radioGroup.types';

  export let id: string;
  export let selectedvalue: string;
  export let options: string;
  export let legend: string;
  export let inline: boolean;
  let eventHandler = new EventHandler();

  $: parsedOptions = options ? (JSON.parse(options) as RadioGroupOption[]) : [];
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
  $: selectedValue = selectedvalue ? selectValue(selectedvalue) : selectedvalue;

  function selectValue(value: string) {
    selectedValue = value;
    eventHandler.dispatch('change', selectedValue);
  }
</script>

<div {id} class="radio-group-container" {...attributes}>
  <fieldset class="mc-field mc-field--group">
    {#if legend && legend.length}
      <legend class="mc-field__legend">
        {legend}
      </legend>
    {/if}

    <div
      class="mc-field__container {inline ? 'mc-field__container--inline' : ''}"
    >
      {#each parsedOptions as opt (opt.id)}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="mc-radio mc-field__item {$$props.class}"
          on:click={() => selectValue(opt.value)}
        >
          <input
            type="radio"
            class="mc-radio__input"
            id={opt.id}
            name={opt.name}
            bind:group={selectedValue}
            value={opt.value}
            disabled={opt.disabled}
          />
          <label for={opt.id} class="mc-radio__label">{opt.label}</label>
        </div>
      {/each}
    </div>
  </fieldset>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.radio';
  @import '@mozaic-ds/styles/components/c.fields';
</style>
